<template>
    <h1>{{ $t("pageNotFound") }}</h1>
</template>

<script setup lang="ts">
</script>

<style scoped>
h1 {
    text-align: center;
}
</style>
